export default {
    API_URL: 'https://admin.into-it.co.uk',
    MEDIA_URL: 'https://api.into-it.co.uk'
}
